module.exports = __webpack_public_path__ + "static/media/collapse-arrow.642bfcfb.svg";